import { faHome, faTrashAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useLayoutEffect, useRef, useState } from "react"
import { createPortal } from "react-dom"
import { Link, useNavigate } from "react-router-dom"
import { useStickerSectionStore } from "../EditorStore"
import { resetCanvas } from "../ResetCanvas"
import { androidPhones, iOSPhones } from "../utils/phoneDetails"

export const FullscreenModal = ({
    children,
    transparentBackground = false
}: {
    children: JSX.Element,
    transparentBackground?: boolean
}) => {
    return createPortal(
        <div
            style={{
                position: "fixed",
                top: "0",
                left: "0",
                height: "100%",
                width: "100%",
                backgroundColor: transparentBackground
                    ? "rgba(0, 0, 0, 0)"
                    : "rgba(0, 0, 0, 0.7)",
                zIndex: "99999999999",
            }}
        >
            {children}
        </div>,
        document.body
    );
};


export default function NavBar() {

    const navigate = useNavigate()

    const [showClearCanvasConfirmationModal, setShowClearCanvasConfirmationModal] = useState(false)
    const tutorialRef = useRef<SVGSVGElement>(null)
    const phoneModel = useStickerSectionStore((state) => state.phoneModel);
    const caseFinish = useStickerSectionStore((state) => state.caseFinish)
    const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });
    const isPortrait = useStickerSectionStore((state) => state.isPortrait)

    useLayoutEffect(() => {
        if (tutorialRef.current) {
            const rect = tutorialRef.current.getBoundingClientRect();
            console.log('Tooltip position:', rect, tooltipPos);
            setTooltipPos({
                top: rect.top + window.scrollY,
                left: rect.left + window.scrollX + rect.width / 2,
            });
        }
    }, []);

    const clearCanvasConformationModalChild = () => {
        return (
            <div onClick={() => setShowClearCanvasConfirmationModal(false)}
                style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div style={{
                    height: "20%",
                    width: "60%",
                    backgroundColor: "#6b9e9e",
                    borderRadius: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "20px",
                    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
                    color: "#ffffff"
                }}>
                    <div style={{ fontSize: "16px", fontWeight: 500, textAlign: "center" }}>
                        Are you sure you want to clear the canvas? This cannot be undone!
                    </div>
                    <div style={{ display: "flex", gap: "16px" }}>
                        <button onClick={() => setShowClearCanvasConfirmationModal(false)} style={{
                            padding: "8px 16px",
                            backgroundColor: "#5a7a7a",
                            borderRadius: "10px",
                            border: "none",
                            fontWeight: 500,
                            color: "#ffffff",
                            WebkitTapHighlightColor: "transparent",
                        }}>
                            No
                        </button>
                        <button
                            onClick={resetCanvas}
                            style={{
                                padding: "8px 16px",
                                backgroundColor: "#3d5a5a",
                                color: "#ffffff",
                                borderRadius: "10px",
                                border: "none",
                                fontWeight: 500,
                                WebkitTapHighlightColor: "transparent",
                            }}>
                            Yes
                        </button>
                    </div>
                </div>
            </div>
        )
    }


    return (
        <div style={{ color: "red", width: isPortrait ? "10vw" : "100%", height: "50vh", position: "absolute", zIndex: "4", paddingTop: isPortrait ? "20%" : "", left: isPortrait ? "0" : "0", top: "1vh", marginLeft: isPortrait ? "1%" : "0%", display: "flex", flexDirection: "column", pointerEvents: "none", gap: "1%", justifyContent: 'end', alignItems: "end", paddingRight: "1vw" }}>

            <div
                style={{
                    height: "50%",
                    width: isPortrait ? "100%" : "5%",
                    border: "2px solid white",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    pointerEvents: "auto",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",

                }}

                onClick={() => navigate('/caseconfiguration')}
            >
                <div
                    style={{
                        transform: "rotate(-90deg)",
                        whiteSpace: "nowrap",
                        color: "white",
                        display: "flex",
                        flexDirection: "row",

                        fontSize: "1.5vh"
                    }}
                >
                    {caseFinish} -{' '}
                    {
                        (iOSPhones.find(p => p.value === phoneModel)?.name ||
                            androidPhones.find(p => p.value === phoneModel)?.name ||
                            "Unknown")
                    }
                </div>
            </div>

            <div style={{ height: "33%", width: isPortrait ? "100%" : "5%", border: "2px solid white", borderRadius: "10px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(0, 0, 0, 0.7)", pointerEvents: "auto" }}>
                <Link to="/" style={{ height: "50%", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <FontAwesomeIcon icon={faHome} color="white" />
                </Link>



                <div onClick={() => setShowClearCanvasConfirmationModal(true)} style={{ height: "50%", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <FontAwesomeIcon icon={faTrashAlt} color="white" />
                </div>

                {showClearCanvasConfirmationModal && <FullscreenModal children={clearCanvasConformationModalChild()} />}

            </div>

        </div>
    )
}